import React, { Component } from 'react';
import { Card, Button, Modal, Form, Row, Col, Spinner } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search, CSVExport} from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { fetchAndSetFlashMessage, Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import Dropdown from 'react-bootstrap/Dropdown';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { cloneDeep, isEmpty } from 'lodash';

import "./index.css";
import { Link } from 'react-router-dom';
import { STATUS_CODE_TO_LABEL, TEMPLATES } from '../../../Helpers/constant.js';
import { TcdHeaderFormatter } from '../../../Helpers/tooltip.js';
import Marquee from 'react-fast-marquee';

class ListHistoricalVoiceCampaign extends Component {
	constructor(props) {
		super(props);
		this.state = {
			campaignlist: [],
			selectedCampaignId: 0,
			isButtonDisabled: [],
			confirmStop: false,
			confirmPause: false,
			confirmResume: false,
			confirmRetry: false,
			reloading: false,
			allSelected: false,
			retryOptionStates: {},
			apiRetryOptions: [],
			startDate: '',
            endDate: '',
			loading: false,
			sizePerPage: 10,
			selectedRows: [],
			moduleList: [],
			ttsFlag : false,
			showTable : false,
			continuousFlag: false,
			hasRetries : false,
			hasTcdCount : false,
			alertMessage :'',
			isWebhookModule:false,
			WebhookRetryModal:false 
			
		}
		//<Route path={`${urlPrefix}/campaign-summary`} ><ListCampaign app={props.app} /></Route>
	}
	componentDidMount() {

		const userId = this.props.app.userId;

		fetchAndSetFlashMessage(
			this.props.app.apiPath,
			msg => msg.moduleName === "historical_summary" && msg.action === "view",
			msg => this.setState({ alertMessage: msg })
		);
      
		// Get User Module List
		Fetcher.get(this.props.app.apiPath + '/api/obd/module/list/' + userId)
			.then(res => {
				this.setState({
					moduleList: res
				})
				if (!isEmpty(this.state.moduleList) && (!('error' in this.state.moduleList))) {
					this.state.moduleList.map((fileObj) => {
						 if(fileObj.moduleName === 'TTS'){
                            this.state.ttsFlag = true;
							console.log("TTS Flag :"+this.state.ttsFlag);
						 }
						if(fileObj.moduleName === 'Continuous Campaign'){
                        	this.setState({ continuousFlag: true });
							console.log("Continuous Flag :"+this.state.continuousFlag);
						}
						if(fileObj.moduleName === 'Webhooks'){
                        	this.setState({ isWebhookModule: true });
						}
					})
				}
			})
			.catch(err => { console.log('Error in fetching Modules', err) });


		const timer = setTimeout(() => {
                 this.setState({
					showTable : true
				 })
        }, 2000);
		
		this.getCampaigns();
		const savedSizePerPage = Cookies.get('histoVoicCampSum_S_P_P');
		if (savedSizePerPage) {
			this.setState({ sizePerPage: Number(savedSizePerPage) });
		}
	}

	getCampaigns = () => {
		const userId = this.props.app.userId;
		const data = {
            userId:userId,
            startDate : this.state.startDate?this.formatDate(this.state.startDate):"",
            endDate : this.state.endDate?this.formatDate(this.state.endDate):"",
        }
		// this.props.app.apiPath 
		Fetcher.post(this.props.app.apiPath  + '/api/obd/campaign/historical',{ headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				const hasRetries = this.hasAnyRetries(res);
				const hasTcdCount = this.hasAnyTcdCount(res);

				this.setState({
					campaignlist: res,
					confirmStop: false,
					confirmPause: false,
					confirmResume: false,
					confirmRetry: false,
					hasRetries : hasRetries,
					hasTcdCount : hasTcdCount
				})
			})
			.catch(err => { console.log('Error in fetching Campaigns', err) });
	}

	hasAnyRetries(campaigns) {
		if (Array.isArray(campaigns) && campaigns.length > 0) {
			for (let i = 0; i < campaigns.length; i++) {
				if (campaigns[i].retries > 0) {
					return true;
				}
			}
		}
		return false;
	}

	hasAnyTcdCount(campaigns) {
		if (Array.isArray(campaigns) && campaigns.length > 0) {
			for (let i = 0; i < campaigns.length; i++) {
				const tcdCount = (campaigns[i].retryCount || 0);
				if (tcdCount > 0) {
					return true;
				}
			}
		}
		return false;
	}


	refreshPage = () => {
		this.setState({ reloading: true });
		//window.location.reload();

		setTimeout(() => {
			window.location.reload(false);
		}, 500);
	}

	downloadReport = (index, campaignId, type) => {
		const data = {
			"campaignId": campaignId,
			"reprtType": type
		};
		return Fetcher.post(this.props.app.apiPath + '/api/obd/report/download', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				alert(res.message);
				//document.getElementById('report-' + index).disabled = false;
				//document.getElementById('report-' + index).innerHTML = "Download";
				window.open(this.props.app.reportPath + '/reports/' + campaignId + '.zip', 'Download');
			})
			.catch(err => { console.log('Error in Downloading Report', err) });
	}

	generateReport = (index, campaignId, reportType) => {
		const userId = this.props.app.userId;
		const data = {
			"campaignId": campaignId,
			"reportType": reportType,
			"userId":userId
		};
		return Fetcher.post(this.props.app.apiPath + '/api/obd/report/generate', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {

				alert(res.message);
				this.getCampaigns();
				
				//document.getElementById("greport-" + index).disabled = true;
				//document.getElementById('greport-' + index).innerHTML = "Preparing";
				
			})
			.catch(err => { console.log('Error in Generating Report', err) });
	}

	downloadPending = (index, campaignId) => {
		const data = {
			"campaignId": campaignId,
			"reportType": 'pending_data'
		};
		return Fetcher.post(this.props.app.apiPath + '/api/obd/report/pending', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				//let csvRows = res.join('\n');
				let csvRows = res.map(item => item.substring(0, 10)).join('\n');
				// Create a Blob and initiate the download
				const blob = new Blob([csvRows], { type: 'text/csv' });
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = 'pending_data_'+campaignId+'.csv';
				link.click();
			})
		.catch(err => { 
			Notify.notify('Something went wrong');
			console.log('Error in Downloading Report', err) });
	}

	confirmStop = (status, campaignId) => {
		this.setState({
			confirmStop: status,
			selectedCampaignId: campaignId
		});
	}

	confirmPause = (status, campaignId) => {
		this.setState({
			confirmPause: status,
			selectedCampaignId: campaignId
		});
	}

	confirmResume = (status, campaignId) => {
		this.setState({
			confirmResume: status,
			selectedCampaignId: campaignId
		});
	}

	confirmRetry = (status, campaignId) => {
		if(this.state.loading) {
			return;
		}
		this.setState({
			confirmRetry: status,
			selectedCampaignId: campaignId
		});
		if (status) {
			Fetcher.get(this.props.app.apiPath + '/api/obd/campaign/retry/options/' + campaignId)
			.then(res => {
				const retryOptionStates = {};
                res.forEach(option => {
                    retryOptionStates[option.optionName] = false;
                });
                this.setState({
                    apiRetryOptions: res,
					retryOptionStates: retryOptionStates 
                });
            })
            .catch(err => {
                console.log('Error in fetching retry options', err);
            });
		}
	}

	stopCampaign = () => {
		const campaignId = this.state.selectedCampaignId;
		const data = {
			campaignId: campaignId
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/stop', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();
			})
			.catch(err => {
				console.log('Error in Stopping', err);
			});
	}


    bulkGenerateReport = () => {
			 const userId = this.props.app.userId;
             console.log("select ids : "+ this.state.selectedRows);

			 const idsToFind = this.state.selectedRows;

			 const filteredRecords = this.state.campaignlist.filter(record => idsToFind.includes(record.campaignId));

			 const totalCallSum = filteredRecords.reduce((sum, record) => sum + record.numbersUploaded, 0);

			 console.log("Total Calls : "+totalCallSum);

			 if(totalCallSum>1000000){

				Notify.notify('Total Numbers Limit cannot exceed 10 Lakhs.');
				this.setState({ reloading: true });

		       setTimeout(() => {
			       window.location.reload(false);
		       }, 2500);
			   return;
			 }

			 const data = {
			     "campaignId":0,
                 "reportType":"bulk",
                 "campaignIds":this.state.selectedRows.toString(),
				 "userId":userId
		     };

             console.log("JSON : "+JSON.stringify(data));

			 return Fetcher.post(this.props.app.apiPath + '/api/obd/report/generate', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.setState({ reloading: true });

		       setTimeout(() => {
			       window.location.reload(false);
		       }, 2500);
			})
			.catch(err => { console.log('Error in Generating Report', err) });


	}


	pauseCampaign = () => {
		const campaignId = this.state.selectedCampaignId;
		const data = {
			campaignId: campaignId
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/pause', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();
			})
			.catch(err => {
				console.log('Error in Pause', err);
			});
	}
	
	resumeCampaign = () => {
		const campaignId = this.state.selectedCampaignId;
		const data = {
			campaignId: campaignId,
			userId: this.props.app.userId
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/resume', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();
			})
			.catch(err => {
				console.log('Error in Resume', err);
			});
	}

	retryCampaign = () => {
		this.setState({ loading: true });
		const userId = this.props.app.userId;
		const campaignId = this.state.selectedCampaignId;
		const { retryOptionStates, allSelected } = this.state;
		let selectedOptions;
		if (allSelected) {
			selectedOptions = ["All"];
		} else {
			selectedOptions = Object.keys(retryOptionStates).filter((option) => retryOptionStates[option]);
		}

		if (selectedOptions.length === 0) {
			alert("Please select at least one option.");
			this.setState({ loading: false });
			return;
		}
		const selectedOptionsString = selectedOptions.join(':');
		const data = {
			campaignId: campaignId,
			userId: userId,
			selectedOptions: selectedOptionsString
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/retry', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();
				// Reset all option states to false
				const updatedOptionStates = {};
				Object.keys(retryOptionStates).forEach(option => {
					updatedOptionStates[option] = false;
				});
				this.setState({ 
					retryOptionStates: updatedOptionStates,
					allSelected: false,
					loading: false
				});
			})
			.catch(err => {
				console.log('Error in Retry', err);
				this.setState({ loading: false  });
			});
	}

	handleStartDateChange = (date) => {
		this.setState({
			startDate: date,
	    });
    };

    handleEndDateChange = (date) => {
    		this.setState({
    			endDate: date,
    	 });
    };

	formatDate = (date) => {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
	
		return `${year}-${month}-${day}`;
	};

	searchCdr = async (e) => {
        e.preventDefault();
        let sDate = "";
        let eDate ="";
        if(this.state.startDate === ""){
                 sDate = this.state.startDate
        }else{
            sDate =  this.formatDate(this.state.startDate)
        }
        if(this.state.endDate === ""){
                 eDate = this.state.endDate
        }else{
            eDate =  this.formatDate(this.state.endDate)
        }
        const userId = this.props.app.userId;
		const data = {
            userId:userId,
            startDate : sDate,
            endDate : eDate,
        }
		Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/historical' ,{ headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				this.setState({
					campaignlist: res,
					confirmStop: false,
					confirmPause: false,
					confirmResume: false,
					confirmRetry: false
				})
			})
			.catch(err => { console.log('Error in fetching Campaigns', err) });
    }

	retryWebhook = () => {
		this.setState({ loading: true });
		const campaignId = this.state.selectedCampaignId;
		const data = {
			campaignId: campaignId,
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/retry/failed/webhook', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();

			})
			.catch(err => {
				console.log('Error in Retry', err);
				// this.setState({ loading: false });
			}).finally(() => this.setState({ loading: false, selectedCampaignId: "", WebhookRetryModal: false }));

	}

	toggleCheckedChange = (e, optionName) => {
        const { checked } = e.target;
        if (optionName === 'All') {
            const updatedOptionStates = {};
            Object.keys(this.state.retryOptionStates).forEach((key) => {
                updatedOptionStates[key] = checked;
            });
            this.setState({
                allSelected: checked,
                retryOptionStates: updatedOptionStates,
            });
        } else {
            this.setState((prevState) => ({
                retryOptionStates: {
                    ...prevState.retryOptionStates,
                    [optionName]: checked,
                },
            }));
        }
    };

	handleSizePerPageChange = (newSizePerPage) => {
		this.setState({ sizePerPage: newSizePerPage });
		Cookies.set('histoVoicCampSum_S_P_P', newSizePerPage);
	}


	handleSelectAll = (isSelect) => {
         const { campaignlist } = this.state;
         if (isSelect) {
              this.setState({ selectedRows: campaignlist.map(p => p.campaignId) });
        } else {
            this.setState({ selectedRows: [] });
        }
    };

	handleSelectRow = (row, isSelect) => {
        this.setState(prevState => {
               const selectedRows = [...prevState.selectedRows];
               if (isSelect) {
                            selectedRows.push(row.campaignId);
               } else {
                        const index = selectedRows.indexOf(row.campaignId);
                        if (index > -1) {
                                    selectedRows.splice(index, 1);
                        }
                }
        return { selectedRows };
       });
    };

	isSelectedAll = () => {
       const { campaignlist, selectedRows } = this.state;
       return selectedRows.length === campaignlist.length;
    };

	

	render() {

		const campaigns = this.state.campaignlist;
		let columns = [];

		if(this.state.ttsFlag === true){
		 columns = [
			{
			     dataField: 'select',
                 text: 'Select',
                 headerRenderer: (columnProps, colIndex, expandColumnProps) => (
                <input
                      type="checkbox"
                      checked={this.isSelectedAll()}
                    onChange={(e) => this.handleSelectAll(e.target.checked)}
					 style={{ margin: '0 auto', display: 'block' }}
                />
                ),
                formatter: (cell, row) => (
                  <input type="checkbox" checked={this.state.selectedRows.includes(row.campaignId)}
                    onChange={(e) => this.handleSelectRow(row, e.target.checked)} />
                ),
                headerStyle: { width: '50px' , textAlign: 'center'},
            },
			{
				dataField: 'id',
				text: 'Serial No.',
				sort: false,
				hidden: true
			},
			{
				dataField: 'campaignId',
				text: 'Campaign ID',
				sort: false,
				hidden: false
			},
			{
				dataField: 'campaignName',
				text: 'Campaign Name',
				sort: true,
				searchable: true,
				csvExport: false,
				style: { maxWidth:"288px", whiteSpace: 'normal', wordWrap: 'break-word' }
			}, {
				dataField: 'name',
				text: 'Campaign Name',
				sort: true,
				searchable: true,
				hidden: true,
				csvExport: true
			}, {
				dataField: 'campaignstatus',
				text: 'Campaign Status',
				sort: true,
				searchable: true
			}, {
				dataField: 'templateId',
				text: 'Campaign Type',
				sort: true,
				searchable: true
			},{
				dataField: 'scheduleTime',
				text: 'Start Time',
				sort: true,
				searchable: false
			},{
				dataField: 'endTime',
				text: 'End Time',
				sort: true,
				searchable: false
			},{
				dataField: 'pauseTime',
				text: 'Pause Time',
				sort: true,
				searchable: false
			}, {
				dataField: 'numbersUploaded',
				text: 'Total Numbers',
				sort: false,
				searchable: false
			},{
				dataField: 'totalCallsDialed',
				text: 'TCD',
				headerFormatter: () => (
					<TcdHeaderFormatter
						id="tcd-tooltip"
						text="TCD"
						tooltip="Total Calls Dialed (Calls Dialed + Retry Count)"
					/>),
				sort: false,
				searchable: false,
				headerStyle:{minWidth:"90px"},
				hidden: this.props.app.role === 'ROLE_USER' && !this.state.hasTcdCount,
				csvExport: !(this.props.app.role === 'ROLE_USER' && !this.state.hasTcdCount)

			}, {
				dataField: 'numbersProcessed',
				text: 'Calls Dialed',
				sort: false,
				searchable: false
			}, {
				dataField: 'callsSubmitted',
				text: 'Pending Calls',
				sort: false,
				searchable: false,
				csvExport: false,
				hidden: this.state.continuousFlag
			},{
				dataField: 'callsSubmittedCsv',
				text: 'Pending Calls',
				sort: false,
				searchable: false,
				hidden: true,
				csvExport: true
			},{
				dataField: 'failedCount',
				text: 'Failed Count',
				sort: true,
				searchable: false,
				hidden: !this.state.continuousFlag, // Only show when continuous campaign is present
				csvExport: this.state.continuousFlag
        	},{
				dataField: 'callsConnected',
				text: 'Connected Calls',
				sort: false,
				searchable: false,
				csvExport: false
			},{
				dataField: 'callsConnectedCsv',
				text: 'Connected Calls',
				sort: false,
				searchable: false,
				hidden: true,
				csvExport: true
			},{
				dataField: 'pulses',
				text: 'Total Pulses',
				sort: true,
				searchable: false
			},{
				dataField: 'dndCount',
				text: 'DnD Count',
				sort: true,
				searchable: false
			},{
				dataField: 'dtmfCount',
				text: 'Dtmf Count',
				sort: true,
				searchable: false,
				csvExport: false
			},{
				dataField: 'dtmf1Count',
				text: 'Dtmf1 Count',
				sort: true,
				searchable: false,
				csvExport: false
			},{
				dataField: 'dtmf2Count',
				text: 'Dtmf2 Count',
				sort: true,
				searchable: false,
				csvExport: false
			},{
				dataField: 'webhookFailedCount',
				text: 'Webhook Failed Count',
				sort: true,
				searchable: false,
				hidden: !this.state.isWebhookModule,
				csvExport: false
			},{
                dataField: 'webhookFailedCountCsv',
                text: 'Webhook Failed Count',
                hidden: true,
                csvExport: this.state.isWebhookModule
			},
			// {
			// 	dataField: 'webhookLog',
			// 	text: 'Webhook Log',
			// 	sort: true,
			// 	searchable: false,
			// 	hidden: !this.state.isWebhookModule,
			// 	csvExport: this.state.isWebhookModule
			// },{
			// 	dataField: 'webhookSuccessCount',
			// 	text: 'Webhook Success Count',
			// 	sort: true,
			// 	searchable: false,
			// 	hidden: !this.state.isWebhookModule,
			// 	csvExport: this.state.isWebhookModule
			// },{
			// 	dataField: 'retryWebhookCount',
			// 	text: 'Webhook Retry Count',
			// 	sort: true,
			// 	searchable: false,
			// 	hidden: !this.state.isWebhookModule,
			// 	csvExport: this.state.isWebhookModule
			// },
			{
				dataField: 'dtmfCountCsv',
				text: 'Dtmf Count',
				sort: true,
				searchable: false,
				hidden: true,
				csvExport: true
			},{
				dataField: 'dtmf1CountCsv',
				text: 'Dtmf1 Count',
				sort: true,
				searchable: false,
				hidden: true,
				csvExport: true
			},{
				dataField: 'dtmf2CountCsv',
				text: 'Dtmf2 Count',
				sort: true,
				searchable: false,
				hidden: true,
				csvExport: true
			},{
				dataField: 'smsCount',
				text: 'SMS Count',
				sort: true,
				searchable: false,
				csvExport: false
			},
			{
				dataField: 'smsCount1',
				text: 'SMS Count',
				sort: true,
				searchable: false,
				csvExport: true,
				hidden: true
			},
			{
				dataField: 'retryCount',
				text: 'Retry Count',
				sort: true,
				searchable: false,
				hidden:!this.state.hasRetries,
				csvExport:this.state.hasRetries
			},{
				dataField: 'retries',
				text: 'Is Retry',
				sort: true,
				searchable: false,
				hidden: true
			},
			{
				dataField: 'ttsCount',
				text: 'Total Variable Count',
				sort: false,
				hidden: false,
				csvExport: true
			},
			{
				dataField: 'retries',
				text: 'No. Of retries',
				sort: true,
				searchable: false,
				hidden:!this.state.hasRetries,
				csvExport:this.state.hasRetries
			},{
				dataField: 'fullReportStatus',
				text: 'Action',
				sort: false,
				searchable: false,
				csvExport: false
			}, {
				dataField: 'retry',
				text: 'Retry',
				sort: false,
				searchable: false,
				csvExport: false
			},];
		}
		else{

			columns = [
			{
			     dataField: 'select',
                 text: 'Select',
                 headerRenderer: (columnProps, colIndex, expandColumnProps) => (
                <input
                      type="checkbox"
                      checked={this.isSelectedAll()}
                    onChange={(e) => this.handleSelectAll(e.target.checked)}
					 style={{ margin: '0 auto', display: 'block' }}
                />
                ),
                formatter: (cell, row) => (
                  <input type="checkbox" checked={this.state.selectedRows.includes(row.campaignId)}
                    onChange={(e) => this.handleSelectRow(row, e.target.checked)} />
                ),
                headerStyle: { width: '50px' , textAlign: 'center'},
            },
			{
				dataField: 'id',
				text: 'Serial No.',
				sort: false,
				hidden: true
			},
			{
				dataField: 'campaignId',
				text: 'Campaign ID',
				sort: false,
				hidden: false
			},
			{
				dataField: 'campaignName',
				text: 'Campaign Name',
				sort: true,
				searchable: true,
				csvExport: false,
				style: { maxWidth:"288px", whiteSpace: 'normal', wordWrap: 'break-word' }
			}, {
				dataField: 'name',
				text: 'Campaign Name',
				sort: true,
				searchable: true,
				hidden: true,
				csvExport: true
			}, {
				dataField: 'campaignstatus',
				text: 'Campaign Status',
				sort: true,
				searchable: true
			}, {
				dataField: 'templateId',
				text: 'Campaign Type',
				sort: true,
				searchable: true
			},{
				dataField: 'scheduleTime',
				text: 'Start Time',
				sort: true,
				searchable: false
			},{
				dataField: 'endTime',
				text: 'End Time',
				sort: true,
				searchable: false
			},{
				dataField: 'pauseTime',
				text: 'Pause Time',
				sort: true,
				searchable: false
			}, {
				dataField: 'numbersUploaded',
				text: 'Total Numbers',
				sort: false,
				searchable: false
			},{
				dataField: 'totalCallsDialed',
				text: 'TCD',
				headerFormatter: () => (
					<TcdHeaderFormatter
						id="tcd-tooltip"
						text="TCD"
						tooltip="Total Calls Dialed (Calls Dialed + Retry Count)"
					/>),
				sort: false,
				searchable: false,
				headerStyle:{minWidth:"90px"},
				hidden: this.props.app.role === 'ROLE_USER' && !this.state.hasTcdCount,
				csvExport: !(this.props.app.role === 'ROLE_USER' && !this.state.hasTcdCount)

			}, {
				dataField: 'numbersProcessed',
				text: 'Calls Dialed',
				sort: false,
				searchable: false
			}, {
				dataField: 'callsSubmitted',
				text: 'Pending Calls',
				sort: false,
				searchable: false,
				csvExport: false,
				hidden: this.state.continuousFlag // Hide when continuous campaign is present
			},{
				dataField: 'failedCount',
				text: 'Failed Count',
				sort: true,
				searchable: false,
				hidden: !this.state.continuousFlag, // Only show when continuous campaign is present
				csvExport: this.state.continuousFlag
        	},{
				dataField: 'callsSubmittedCsv',
				text: 'Pending Calls',
				sort: false,
				searchable: false,
				hidden: true,
				csvExport: true
			},{
				dataField: 'callsConnected',
				text: 'Connected Calls',
				sort: false,
				searchable: false,
				csvExport: false
			},{
				dataField: 'callsConnectedCsv',
				text: 'Connected Calls',
				sort: false,
				searchable: false,
				hidden: true,
				csvExport: true
			},{
				dataField: 'pulses',
				text: 'Total Pulses',
				sort: true,
				searchable: false
			},{
				dataField: 'dndCount',
				text: 'DnD Count',
				sort: true,
				searchable: false
			},{
				dataField: 'dtmfCount',
				text: 'Dtmf Count',
				sort: true,
				searchable: false,
				csvExport: false
			},{
				dataField: 'dtmf1Count',
				text: 'Dtmf1 Count',
				sort: true,
				searchable: false,
				csvExport: false
			},{
				dataField: 'dtmf2Count',
				text: 'Dtmf2 Count',
				sort: true,
				searchable: false,
				csvExport: false
			},{
				dataField: 'webhookFailedCount',
				text: 'Webhook Failed Count',
				sort: true,
				searchable: false,
				hidden: !this.state.isWebhookModule,
				csvExport: false
			},{
                dataField: 'webhookFailedCountCsv',
                text: 'Webhook Failed Count',
                hidden: true,
                csvExport: this.state.isWebhookModule
			},
			// {
			// 	dataField: 'webhookLog',
			// 	text: 'Webhook Log',
			// 	sort: true,
			// 	searchable: false,
			// 	hidden: !this.state.isWebhookModule,
			// 	csvExport: this.state.isWebhookModule
			// },{
			// 	dataField: 'webhookSuccessCount',
			// 	text: 'Webhook Success Count',
			// 	sort: true,
			// 	searchable: false,
			// 	hidden: !this.state.isWebhookModule,
			// 	csvExport: this.state.isWebhookModule
			// },{
			// 	dataField: 'retryWebhookCount',
			// 	text: 'Webhook Retry Count',
			// 	sort: true,
			// 	searchable: false,
			// 	hidden: !this.state.isWebhookModule,
			// 	csvExport: this.state.isWebhookModule
			// },
			{
				dataField: 'dtmfCountCsv',
				text: 'Dtmf Count',
				sort: true,
				searchable: false,
				hidden: true,
				csvExport: true
			},{
				dataField: 'dtmf1CountCsv',
				text: 'Dtmf1 Count',
				sort: true,
				searchable: false,
				hidden: true,
				csvExport: true
			},{
				dataField: 'dtmf2CountCsv',
				text: 'Dtmf2 Count',
				sort: true,
				searchable: false,
				hidden: true,
				csvExport: true
			},{
				dataField: 'smsCount',
				text: 'SMS Count',
				sort: true,
				searchable: false,
				csvExport: false
			},
			{
				dataField: 'smsCount1',
				text: 'SMS Count',
				sort: true,
				searchable: false,
				csvExport: true,
				hidden: true
			},
			{
				dataField: 'retryCount',
				text: 'Retry Count',
				sort: true,
				searchable: false,
				hidden:!this.state.hasRetries,
				csvExport:this.state.hasRetries
			},{
				dataField: 'retries',
				text: 'Is Retry',
				sort: true,
				searchable: false,
				hidden: true
			},
			{
				dataField: 'ttsCount',
				text: 'Total Variable Count',
				sort: false,
				hidden: true,
				csvExport: false
			},
			{
				dataField: 'retries',
				text: 'No. Of retries',
				sort: true,
				searchable: false,
				hidden:!this.state.hasRetries,
				csvExport:this.state.hasRetries
			},{
				dataField: 'fullReportStatus',
				text: 'Action',
				sort: false,
				searchable: false,
				csvExport: false
			}, {
				dataField: 'retry',
				text: 'Retry',
				sort: false,
				searchable: false,
				csvExport: false,
				hidden : true
			},];

		}

		const products = Array.isArray(campaigns) ? campaigns.map((campaign, index) => {
			const template = TEMPLATES[campaign.templateId] ?? ""
			const status = STATUS_CODE_TO_LABEL[campaign.campaignStatus] ?? '';
			
			let action = [];
			let retry = [];
			//let 
			const isTTSTemplate = campaign.templateId === 7 || campaign.templateId === 8 || campaign.templateId === 9;
			action.push(<Dropdown id="dd">
				<Dropdown.Toggle className='btn-sm'>Take Action</Dropdown.Toggle>
					<Dropdown.Menu style={{ width: 'max-content' }}>
						{ (!this.state.continuousFlag) && <Dropdown.Item key={`clone-campaign-${index}`} href={`${this.props.app.urlPrefix}/clone-campaign/${campaign.campaignId}`}>Clone Campaign</Dropdown.Item>}
						{(campaign.campaignStatus === 1) && <Dropdown.Item key={`ps-campaign-${index}`} onClick={() => this.confirmPause(true, campaign.campaignId)} href="#">Pause Campaign</Dropdown.Item>}
						{(campaign.campaignStatus === 9) && <Dropdown.Item key={`rs-campaign-${index}`} onClick={() => this.confirmResume(true, campaign.campaignId)} href="#">Resume Campaign</Dropdown.Item>}
						{(campaign.campaignStatus === 1) && <Dropdown.Item key={`st-campaign-${index}`} onClick={() => this.confirmStop(true, campaign.campaignId)} href="#">Stop Campaign</Dropdown.Item>}
						{(campaign.fullReportStatus === '2' || campaign.fullReportStatus === undefined) && <Dropdown.Item id={`greport-${index}`} key={`greport-${index}`} onClick={() => this.generateReport(index, campaign.campaignId, 'full')} href="#">Generate Full Report</Dropdown.Item>}
						{(campaign.webhookLog === '1') && <Dropdown.Item id={`greport-webhook-${index}`} key={`greport-webhook-${index}`} onClick={() => this.generateReport(index, campaign.campaignId, 'webhook')} href="#">Generate Webhook Report</Dropdown.Item>}
						
					</Dropdown.Menu>
				  </Dropdown>);
				// if(campaign.campaignStatus === 2 && campaign.isRetry === 0 && !isTTSTemplate)
				// {
				// 	retry.push(<Link data-tip="Retry" key={`${index}-retryy`} className="btn btn-sm btn-primary" disabled={this.state.loading} onClick={(e) => { this.confirmRetry(true, campaign.campaignId) }}>Retry</Link>);
				// }
				let callsSubmitted=0;
				let dtmfDownload=[];
				dtmfDownload.push(campaign.dtmfCount);
				dtmfDownload.push(' ');
				if(campaign.templateId === 1 || campaign.templateId === 2 || campaign.templateId === 3 )
				{
					if(campaign.dtmfReportStatus === '2' || campaign.dtmfReportStatus === undefined)
					{
						dtmfDownload.push( <a data-tip="" key={`${index}-dtmf`} className="download-report" onClick={( e ) => { this.generateReport( true, campaign.campaignId, 'dtmf' ) }} href="#"><i className="fa fa-download"></i></a>);
					}
				}
				let dtmf1Download=[];
				dtmf1Download.push(campaign.dtmf1Count);
				dtmf1Download.push(' ');
				if(campaign.templateId === 3)
				{
					if(campaign.dtmfReportStatus === '2' || campaign.dtmfReportStatus === undefined)
					{
						dtmf1Download.push( <a data-tip="" key={`${index}-dtmf1`} className="download-report" onClick={( e ) => { this.generateReport( true, campaign.campaignId, 'dtmf1' ) }} href="#"><i className="fa fa-download"></i></a>);
					}
				}
				let dtmf2Download=[];
				dtmf2Download.push(campaign.dtmf2Count);
				dtmf2Download.push(' ');
				if(campaign.templateId === 3)
				{
					if(campaign.dtmfReportStatus === '2' || campaign.dtmfReportStatus === undefined)
					{
						dtmf2Download.push( <a data-tip="" key={`${index}-dtmf2`} className="download-report" onClick={( e ) => { this.generateReport( true, campaign.campaignId, 'dtmf2' ) }} href="#"><i className="fa fa-download"></i></a>);
					}
				}
				let ccDownload=[];
				ccDownload.push(campaign.callsConnected);
				ccDownload.push(' ');
				if(campaign.callsConnected > 0)
				{
					if(campaign.ccReportStatus === '2' || campaign.ccReportStatus === undefined)
					{
						ccDownload.push( <a data-tip="" key={`${index}-cc`} className="download-report" onClick={( e ) => { this.generateReport( true, campaign.campaignId, 'connected_calls' ) }} href="#"><i className="fa fa-download"></i></a>);
					}
				}
				let ccPending=[];
				ccPending.push(campaign.numbersUploaded - campaign.dndCount - campaign.numbersProcessed);
				ccDownload.push(' ');
				ccPending.push( <a data-tip="" key={`${index}-pending`} className="download-report" onClick={( e ) => { this.downloadPending( true, campaign.campaignId ) }} href="#"><i className="fa fa-download"></i></a>);
	
				let smsDownload = [];
				smsDownload.push(campaign.smsCount);
				smsDownload.push(' ');
				if(campaign.smsCount > 0){
					if(campaign.smsStatus == 2 || campaign.smsStatus == undefined){
						smsDownload.push( <a data-tip="" key={`${index}-sms`} className="download-report" onClick={( e ) => { this.generateReport( true, campaign.campaignId, 'sms' ) }} href="#"><i className="fa fa-download"></i></a>);
					}
				}

				let webhookFailedCount = Number(campaign.webhookFailedCount) || 0;

				if (webhookFailedCount > 0) {
				const currentDate = new Date();
				const retryWebhookCount= Number(campaign.retryWebhookCount) || 0;
				const scheduleDate = new Date(
					campaign.scheduleTime.replace(" ", "T")
				);
				const diffTime = currentDate - scheduleDate;
				const diffDays = Math.floor(
					(diffTime) / (1000 * 60 * 60 * 24)
				);
				// console.log({diffDays,retryWebhookCount,scheduleTime:campaign.scheduleTime})
				if (diffDays <= 2 && retryWebhookCount <= 2) {
					webhookFailedCount = <span key={`${index}-retry-cm`}  >{webhookFailedCount}<a href="#" className="download-report" style={{margin:"4px"}} onClick={() => { this.setState({ selectedCampaignId: campaign.campaignId, WebhookRetryModal: true }) }}><i className="fa fa-repeat"></i></a></span>
				}
			}

			return {
				id: index + 1,
				campaignId: campaign.campaignId,
				name: campaign.campaignName,
				campaignName: (campaign.templateId === 0 || campaign.templateId === 1 || campaign.templateId === 2 || campaign.templateId === 7 || campaign.templateId === 8 || campaign.templateId === 9 || campaign.templateId === 3)?<Link key={`${index}-cm`} to={`${this.props.app.urlPrefix}/voice-campaign-info/${campaign.campaignId}`}>{campaign.campaignName}</Link>:campaign.campaignName,
				campaignstatus: status,
				templateId: template,
				scheduleTime: campaign.scheduleTime,
				endTime: campaign.endTime,
				pauseTime: campaign.pauseTime,
				numbersUploaded: campaign.numbersUploaded,
				numbersProcessed: campaign.numbersProcessed,
				callsSubmitted: (campaign.campaignStatus === 7)?ccPending:campaign.numbersUploaded - campaign.dndCount - campaign.numbersProcessed,
				callsSubmittedCsv: campaign.numbersUploaded - campaign.dndCount - campaign.numbersProcessed,
				callsConnected: (campaign.campaignStatus === 2)?ccDownload:campaign.callsConnected,
				callsConnectedCsv: campaign.callsConnected,
				pulses: campaign.pulses,
				dndCount: campaign.dndCount,
				dtmfCount: (campaign.campaignStatus === 2)?dtmfDownload:campaign.dtmfCount,
				dtmf1Count: (campaign.campaignStatus === 2)?dtmf1Download:campaign.dtmf1Count,
				dtmf2Count: (campaign.campaignStatus === 2)?dtmf2Download:campaign.dtmf2Count,
				dtmfCountCsv: campaign.dtmfCount,
				dtmf1CountCsv: campaign.dtmf1Count,
				dtmf2CountCsv: campaign.dtmf2Count,
				smsCount: (campaign.campaignStatus === 2)? smsDownload : campaign.smsCount,
				retryCount: campaign.retryCount,
				//retries: (campaign.retries > 0)?'Yes':'No',
				retries: campaign.retries,
				fullReportStatus: action,
				retry: retry,
				ttsCount : campaign.ttsCount,
				smsCount1 : campaign.smsCount,
				failedCount: campaign.failedCount || 0,
				totalCallsDialed: (campaign.numbersProcessed + (campaign.retryCount || 0)),
				webhookSuccessCount:(campaign.webhookSuccessCount??0),
				webhookLog:(campaign.webhookLog??0),
				webhookFailedCount:webhookFailedCount,
				retryWebhookCount:campaign.retryWebhookCount,
				webhookFailedCountCsv:Number(campaign.webhookFailedCount) || 0
			};
		}) : []
		const { SearchBar, ClearSearchButton } = Search;
		const { ExportCSVButton } = CSVExport;

		const defaultSorted = [{
			dataField: 'scheduleTime',
			order: 'desc'
		}];

		const paginationOption = {
			custom: true,
			totalSize: products.length,
			sizePerPage: this.state.sizePerPage,
			sizePerPageList: [10, 25, 50, 100],
			onSizePerPageChange: this.handleSizePerPageChange
		};
		const filterTime = (date) => {
			const isPastTime = new Date().getTime() > date.getTime();
			return !isPastTime;
			};

		return (
			<Card>
				{this.state.alertMessage && <Marquee className="fade m-2 alert alert-success show" role="alert">{this.state.alertMessage}</Marquee>}
				<Card.Header>Historical Voice Campaign Summary</Card.Header>
				<Card.Body>
					<div className="campaign-list-table-cont">
					<Form className="add-campaign-form" method='post' onSubmit={(e) => this.searchCdr(e)}> 
					        <Row>
						        <Col sm={2}>
                                    <Form.Group className="form-group col-md-12 float-left" style={{ paddingLeft: 0 }}>
					                    <DatePicker
						                    className="form-control"
						                    dateFormat="yyyy-MM-dd"
                                            selected={this.state.startDate}
                                            onChange={this.handleStartDateChange}
                                            placeholderText="Start Date"
					                    />
				                    </Form.Group>
                                </Col>
                                <Col sm={2}>
                                    <Form.Group className="form-group col-md-12 float-left" style={{ paddingLeft: 0 }}>
					                    <DatePicker
						                    className="form-control"
						                    dateFormat="yyyy-MM-dd"
						                    selected={this.state.endDate}
                                            onChange={this.handleEndDateChange}
                                            placeholderText="End Date"
					                    />
				                    </Form.Group>
                                </Col>
                                <Col sm={2}>
                                    <Button variant="primary" type="submit">Search</Button>
                                </Col>
						    </Row>	
					    </Form> 
						{/* <h3>Campaign Summary</h3> */}
						{/*{!isEmpty( this.state.campaignlist ) && <PaginationProvider pagination={paginationFactory( paginationOption )}>*/}
						{ this.state.showTable ? <PaginationProvider pagination={paginationFactory(paginationOption)}>
							{
								({
									paginationProps,
									paginationTableProps
								}) => (<ToolkitProvider 
										keyField="id" 
										data={products} 
										columns={columns} 
										search 
										bootstrap4
										exportCSV={ {
											fileName: 'historical_campaign_summary.csv'
										  } }
										>
									{props => (<div className="">
										Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
										<span className="search-cont"><SearchBar {...props.searchProps} /></span>
										<ClearSearchButton className="btn-primary" {...props.searchProps} />
										<ExportCSVButton className="export-csv btn-primary ml-2" {...props.csvProps}>Export to CSV</ExportCSVButton>
										<Button id="refresh" type="button" className="float-right btn btn-default btn-primary ml-2" onClick={() => this.refreshPage()}>Refresh</Button>
									    { (this.state.selectedRows.length >0 ) ? <Button id="refresh" type="button" className="float-right btn btn-default btn-primary ml-2" onClick={() => this.bulkGenerateReport()}>Generate Bulk Report</Button> : <></>}
										<hr/>
										<BootstrapTable bordered={true} hover defaultSorted={defaultSorted} wrapperClasses="table-responsive" classes="w-auto campaignlist-table" {...props.baseProps} {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
										<PaginationListStandalone {...paginationProps} />
									</div>)}
								</ToolkitProvider>)
							}
						</PaginationProvider> 
						                      : <div className="loader">
                                                          <Spinner animation="border" variant="primary" />
                                                  </div>}
					</div>
					<Modal size="md" show={this.state.confirmStop} onHide={() => this.confirmStop(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Stop Campaign
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to stop this campaign?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmStop(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.stopCampaign} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>
					
					<Modal size="md" show={this.state.WebhookRetryModal} onHide={() => this.setState({ selectedCampaignId: "", WebhookRetryModal: false })}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Rerty Webhook Campaign
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to retry webhook for this campaign?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.setState({ selectedCampaignId: "", WebhookRetryModal: false })} variant="secondary">CANCEL</Button>
							<Button onClick={this.retryWebhook} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>
					<Modal size="md" show={this.state.confirmPause} onHide={() => this.confirmPause(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Pause Campaign
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to pause this campaign?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmPause(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.pauseCampaign} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>

					<Modal size="md" show={this.state.confirmResume} onHide={() => this.confirmResume(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Resume Campaign
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to resume this campaign?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmResume(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.resumeCampaign} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>

					<Modal size="md" show={this.state.confirmRetry} onHide={() => this.confirmRetry(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Retry Campaign
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
						    <Row>
							  Are you sure you want to retry this campaign?
							    <Form.Group className="form-group">
								    {Object.keys(this.state.retryOptionStates).length > 0 ? (
							            <>		
								            {Object.keys(this.state.retryOptionStates).length > 0 && (	  
							                    <Form.Check
							                	  checked={this.state.allSelected}
							                	  onChange={(e) => this.toggleCheckedChange(e, 'All')}
							                	  custom
							                	  label="All"
							                	  id="All"
							                	  type="checkbox"
							                    />
								            )}
							                {Object.keys(this.state.retryOptionStates).map((optionName) => (
							                	<Form.Check
							                		key={optionName}
							                		checked={this.state.retryOptionStates[optionName]}
							                		onChange={(e) => this.toggleCheckedChange(e, optionName)}
							                		custom
							                		label={`${optionName} (${this.state.apiRetryOptions.find(option => option.optionName === optionName)?.count || 0})`}
							                		id={optionName}
							                		type="checkbox"
							                	/>
							                ))}
								        </>
							        ) : (
							        	<p>Checking for retry data count</p>
							        )}
						        </Form.Group>
						    </Row>
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmRetry(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.retryCampaign} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>


					{(this.state.reloading === true) && <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div>}
				</Card.Body>
			</Card>
		);
	}
}


export default ListHistoricalVoiceCampaign;